import React from "react";
import { Card } from "reactstrap";

import { Block, BlockHead, BlockTitle, UserAvatar } from "../../Component";

const UserInfoMainBlock = ({ user }) => {
  const displayName =
    [user?.firstName, user?.lastName].filter(Boolean).join(" ") ||
    user?.username ||
    user?.email ||
    "-";
  const initials =
    displayName !== "-"
      ? displayName
          .split(" ")
          .map((s) => s?.charAt(0))
          .join("")
          .toUpperCase()
          .slice(0, 2)
      : "-";
  const rolesText = Array.isArray(user?.roles)
    ? user.roles.join(", ")
    : user?.roles ?? "-";

  return (
    <Card className="card-inner">
      <Block>
        <BlockHead>
          <BlockTitle tag="h5">Personal Information</BlockTitle>
        </BlockHead>
        <div className="profile-ud-list">
          <div className="profile-ud-item d-flex align-items-center w-15">
            <div className="profile-ud wider">
              <UserAvatar className="xl" text={initials} />
            </div>
          </div>

          <div className="profile-ud-item">
            <div className="profile-ud wider">
              <span className="profile-ud-label">First Name</span>
              <span className="profile-ud-value">{user?.firstName ?? "-"}</span>
            </div>
            <div className="profile-ud wider">
              <span className="profile-ud-label">Last Name</span>
              <span className="profile-ud-value">{user?.lastName ?? "-"}</span>
            </div>
          </div>

          <div className="profile-ud-item">
            <div className="profile-ud wider">
              <span className="profile-ud-label">Email Address</span>
              <span className="profile-ud-value">{user?.email ?? "-"}</span>
            </div>
            <div className="profile-ud wider">
              <span className="profile-ud-label">Roles</span>
              <span className="profile-ud-value">{rolesText}</span>
            </div>
          </div>
        </div>
      </Block>
    </Card>
  );
};

export default UserInfoMainBlock;
